<template>
  <div class="xcard mt-0 pt-1">
    <v-card class="ins-card elevation-3">
      <v-toolbar flat class="ins-hero">
        <v-btn small class="mr-3" @click="$router.back()" color="white" outlined>
          <v-icon left>mdi-arrow-left-bold</v-icon>
          Volver
        </v-btn>
        <div>
          <div class="text-h6 white--text">Pre inscripcion del estudiante</div>
          <div class="text-body-2 white--text">
            Configura el plan, aplica promocion y genera el cronograma de pagos
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="yellow darken-2" class="deep-orange--text text--darken-4" small>
          Paso final
        </v-chip>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-row dense>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2">Resumen</div>
              <div class="text-body-2 text--secondary">
                <b>Programa:</b> {{ programa.codigo }} {{ programa.nombre_compuesto }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Estudiante:</b> {{ $route.query.persona_name }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Asesor ID:</b> {{ $route.query.asesor_id }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Plan de pagos</div>
              <v-select
                v-model="plan_seleccionado"
                :items="programa.planes"
                :loading="loading_programa"
                item-text="nombre"
                item-value="plan_cobro_programa_id"
                label="Seleccione el plan"
                hide-details
                dense
                outlined
                placeholder="Seleccione..."
                return-object
              />

              <div v-if="plan_seleccionado" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Detalle de cobros</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(p, ind) in plan_seleccionado.cobros"
                    :key="ind"
                    class="ma-1"
                    small
                    color="deep-orange lighten-5"
                  >
                    {{ p.nombre }}: Bs. {{ p.monto }} · max {{ p.cuotas }} cuotas
                  </v-chip>
                </v-chip-group>
              </div>

              <div v-if="promo && promo.id && generado && generado.plan_con_descuentos" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Plan con promocion</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(p, ind) in generado.plan_con_descuentos"
                    :key="ind"
                    class="ma-1"
                    small
                    color="light-blue lighten-5"
                  >
                    {{ p.nombre }}: {{ p.monto }} ({{ p.promo_descuento }})
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Promociones</div>
              <v-select
                v-model="promo"
                :items="promociones"
                :loading="loading_promos"
                item-text="nombre"
                item-value="id"
                label="Seleccione la promocion"
                dense
                outlined
                placeholder="Seleccione..."
                clearable
                return-object
              />
              <div v-if="promo && promo.id" class="mt-3">
                <div class="text-body-2">{{ promo.descripcion }}</div>
                <div class="text-body-2 text--secondary">Desde: {{ promo.fecha_inicio }}</div>
                <div class="text-body-2 text--secondary">Hasta: {{ promo.fecha_fin }}</div>
                <div class="text-body-2 text--secondary">Aprobado por: {{ promo.aprobado_por }}</div>
                <v-divider class="my-2"></v-divider>
                <div class="text-body-2 text--secondary mb-1">Beneficios</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(d, ind) in promo.detalle_promocion"
                    :key="ind"
                    class="ma-1"
                    small
                    color="green lighten-5"
                  >
                    {{ d.nombre_concepto }}: {{ d.valor_descuento }} {{ d.is_porcentaje ? '%' : 'Bs.' }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col>

          <!-- <v-col cols="12" class="d-flex justify-end">
            <v-btn
              class="white--text"
              color="deep-orange darken-2"
              :disabled="!plan_seleccionado"
              @click="generar_plan_pagos()"
            >
              <v-icon left>mdi-calculator</v-icon>
              Generar plan de pagos
            </v-btn>
          </v-col> -->

          <v-col v-if="generado && generado.plan" cols="12" class="mt-8">
            <v-row dense>
              <v-col cols="12" lg="7">
                <v-card outlined>
                  <v-card-title class="text-subtitle-2">Cronograma de pagos</v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="generado.plan"
                    :items-per-page="150"
                    item-key="index"
                    hide-default-footer
                    class="elevation-1 tabla-pagos"
                    :item-class="rowClass"
                  >
                    <template v-slot:item.monto="{ item }">
                      <span>Bs. {{ item.monto }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>

              <v-col cols="12" lg="5">
                <v-expansion-panels multiple focusable>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="d-flex align-center justify-space-between" style="width: 100%;">
                        <span>Comprobante de pago</span>
                        <v-chip
                          x-small
                          :color="comprobanteData && comprobanteData.xbase64 ? 'green lighten-5' : 'grey lighten-4'"
                          :class="comprobanteData && comprobanteData.xbase64 ? 'green--text text--darken-3' : 'grey--text text--darken-2'"
                        >
                          {{ comprobanteData && comprobanteData.xbase64 ? 'Cargado' : 'Pendiente' }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <ComprobantePago
                        @comprobante-guardado="handleComprobanteGuardado($event,'comprobantex')"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div class="d-flex align-center justify-space-between" style="width: 100%;">
                        <span>Documento de identidad</span>
                        <v-chip
                          x-small
                          :color="documentoData && documentoData.xbase64 ? 'green lighten-5' : 'grey lighten-4'"
                          :class="documentoData && documentoData.xbase64 ? 'green--text text--darken-3' : 'grey--text text--darken-2'"
                        >
                          {{ documentoData && documentoData.xbase64 ? 'Cargado' : 'Pendiente' }}
                        </v-chip>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <documentoFData
                        @comprobante-guardado="handleComprobanteGuardado($event,'documentox')"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="d-flex justify-center mt-8">
            <v-btn
              color="green"
              class="white--text"
              :loading="loading"
              :disabled="!generado || !generado.plan || generado.plan.length === 0"
              @click="realizar_ins()"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Proceder a pre inscribir
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <confirmarModal ref="refconfirmarModal" />
    
  </div>
</template>

<style scoped>
  .ins-card {
    border-radius: 16px;
    overflow: hidden;
  }
  .ins-hero {
    min-height: 90px;
    background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
  }
  ::v-deep .grupo-par {
    background-color: #fcfcfc!important;
  }

  ::v-deep .grupo-impar {
    background-color: #f1f5ff!important;
  }
</style>

<script>
  import { headers, getprograma, getpromociones, generar_plan, rowClassX,realizar_inscripcion_from_preins, realizar_inscripcion } from './utils';
  import confirmarModal from './confirmar-modal.vue';
  import ComprobantePago from '@/components/ComprobantePago.vue';
  import documentoFData from '@/components/documentoFData.vue';
  import { createPreRegistro, update_prospecto_estado } from '../utils';



  export default {
    components: {confirmarModal,ComprobantePago,documentoFData},
    data() {
      return {
        loading: false,
        loading_programa: false,
        loading_promos: false,
        programa: {},
        plan_seleccionado: null,
        promociones: [],
        promo: {},
        generado: {},
        headers: headers, 
        comprobanteData: {xbase64:null},
        documentoData: {xbase64:null},
      };
    },
    watch: {
      plan_seleccionado() {
        this.generado = {};
        this.generar_plan_pagos()
      },
      promo() {
        // this.generado = {};
        this.generar_plan_pagos() 
      }
    },
    methods: {
      handleComprobanteGuardado(data, tipo) {
        window.console.log("Comprobante guardado:", data);
        if(tipo == 'comprobantex'){
          this.comprobanteData.archivo = data.archivo
          this.comprobanteData.comentario = data.comentario
          this.comprobanteData.fechaPago = data.fechaPago
          this.comprobanteData.monto = data.monto
        }
        else if(tipo == 'documentox'){
          this.documentoData.archivo = data.archivo
          this.documentoData.comentario = data.comentario
          this.documentoData.fechaPago = data.fechaPago
          this.documentoData.monto = data.monto
        }

        if (!data.archivo) {
          window.console.error("Error: No se encontró un archivo en data.archivo");
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(data.archivo);
        reader.onload = () => {  // Usamos una arrow function para mantener el contexto de `this`
          if(tipo == 'comprobantex'){
            this.comprobanteData.archivoComprobante = reader.result.split(",")[1];
            this.comprobanteData.xbase64 = reader.result; 

          }else if(tipo == 'documentox') {
            this.documentoData.archivoComprobante = reader.result.split(",")[1];
            this.documentoData.xbase64 = reader.result; 
          }
        };
        reader.onerror = (error) => {
          window.console.error("Error al convertir el archivo a Base64:", error);
        }; 
      }, 
      async getprogramadata() {
        this.loading_programa = true;
        const res = await getprograma(this.$route.params.programa_id);
        this.loading_programa = false;
        if (!res.planes) res.planes = [];
        res.planes.forEach((x) => {
          x.cobros.forEach((c) => {
            if (c.monto == 1) c.monto = 0;
          });
        });
        this.programa = res;
        this.programa.planes = res.planes.filter((x) => x.estado);
      },
      async getpromos() {
        this.loading_promos = true;
        const res = await getpromociones(this.$route.params.programa_id);
        this.loading_promos = false;
        if (res && res.data) {
          this.promociones = res.data;
          if (res.data.length == 1) this.promo = res.data[0];
        }
      },
      rowClass(item) {
        return rowClassX(item, this.incluir_deuda_q10_in_plan);
      },
      generar_plan_pagos() {
        const cobros = JSON.parse(JSON.stringify(this.plan_seleccionado.cobros));
        const res = generar_plan(this.promo, cobros);
        window.console.log(res);
        this.generado = res; 
      },

      async save_docs(){ 
        if(!this.comprobanteData || !this.comprobanteData.xbase64){
          return;
        }
        // hasta ahora, en realidad prospecto_id siempre es null
        // ya que en la vista de pre inscritos no se cuenta con el prospecto_id 
        // porque esta jalando al otro servicio de mis_inscripciones
        if(!this.$route.query.prospecto_id){
          return;
        }

        const new_preregistro = { documentos: [] };
        new_preregistro.prospecto_id = this.$route.query.prospecto_id; 
        new_preregistro.estado = 'PENDIENTE_VALIDACION';
        new_preregistro.tipo_inscripcion = 'POSGRADUAL';
        new_preregistro.plan_pago = 'CREDITO';
        new_preregistro.fecha_inscripcion = '2026-03-05T20:15:00Z';
        
        const tipo = 'COMPROBANTE_PAGO'
        const d = { tipo: tipo, base64: this.comprobanteData.xbase64, nombre_archivo: tipo };
        new_preregistro.documentos.push(d)

        if(this.documentoData && this.documentoData.xbase64){
          const tipo = 'CARNET_IDENTIDAD'
          const d = { tipo: tipo, base64: this.documentoData.xbase64, nombre_archivo: tipo };
          new_preregistro.documentos.push(d)
        }
        
        const res = await createPreRegistro(new_preregistro);
        window.console.log('createPreRegistro (respaldo)', res);
        
      },
      async saveEstadoProspecto(estado){
        if(!this.$route.query.prospecto_id) return;

        const dt = {
          prospecto_id: this.$route.query.prospecto_id,
          estado: estado
        }
        await update_prospecto_estado(dt)
      },
      async realizar_ins(){
        const resumen = {
          programa: `${this.programa.codigo || ''} ${this.programa.nombre_compuesto || ''}`.trim(),
          estudiante: this.$route.query.persona_name || '',
          plan: this.plan_seleccionado ? this.plan_seleccionado.nombre : 'No seleccionado',
          promocion: (this.promo && this.promo.id) ? this.promo.nombre : 'Sin promocion',
          plan_pagos: (this.generado && this.generado.plan) ? this.generado.plan : [],
          comprobante: !!(this.comprobanteData && (this.comprobanteData.xbase64 || this.comprobanteData.archivoComprobante)),
          documento: !!(this.documentoData && (this.documentoData.xbase64 || this.documentoData.archivoComprobante)),
        };
        const aceptar = await this.$refs.refconfirmarModal.openmodal(resumen);
        if (!aceptar) return;

        const inscrip = {
            asesor_id: parseInt(this.$route.query.asesor_id),
            canal_id: null,
            estudiante_id: parseInt(this.$route.query.persona_id),
            plan_cobro_programa_id: this.plan_seleccionado.plan_cobro_programa_id,
            programa_id: parseInt(this.$route.params.programa_id),
            registrado_por: this.$store.state.DATA_USER.id,
            tipo_pago: true,
            plan_pagos:this.generado.plan, 
        }
        if (this.comprobanteData && this.comprobanteData.xbase64){
          inscrip.monto= this.comprobanteData.monto;
          inscrip.fecha_pago= this.comprobanteData.fechaPago;
          inscrip.observaciones_pago= this.comprobanteData.comentario;
          inscrip.comprobante_pago= this.comprobanteData.archivoComprobante;
        }

        this.loading = true;
        await this.save_docs()
        
        const res = await realizar_inscripcion(inscrip) 
        window.console.log('ressss', res);
        
        if(res && res.enrollment_id){
            this.$root.$notify.show(`inscrito correctamente ID: ${res.enrollment_id}`, { color: 'purple', x: 'right' });
            await this.saveEstadoProspecto('INSCRITO')
            this.loading = false;
            this.$router.back()
        }else if(res && res.error){
          if(res.error == 'Error, el estudiante se encuentra en un estado inscrito.'){
            await this.saveEstadoProspecto('INSCRITO')
            this.$root.$notify.show(res.error, { color: 'red', x: 'right' });

          }else if(res.error == 'Error, el estudiante se encuentra en un estado preinscrito.'){
            await this.saveEstadoProspecto('PREINSCRITO')
            
            inscrip.inscripcion_id = parseInt(this.$route.query.ins_id)
            const res2 = await realizar_inscripcion_from_preins(inscrip);
            
            if(res2 && res2.error){
              this.$root.$notify.show(res2.error, { color: 'red', x: 'right' });
            }else if(res2 && res2.inscripcion_id){
              this.$root.$notify.show(`inscrito correctamente ID: ${res2.inscripcion_id}`, { color: 'purple', x: 'right' });
              this.loading = false;
              this.$router.back()

            }else{
              window.console.log('res2',res2);
            }

          }
          
        }else{
          this.$root.$notify.show('Algo salio mal :(', { color: 'red', x: 'right' });
        }
        this.loading = false;
        
      }
    },
    mounted() { 
      this.getprogramadata();
    },
  };
</script>
